import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from 'common/types';
import { baseQuery } from 'redux/reducers/settings';



export interface IGalleryItem {
  id?: number;
  folder_name: string;
  file_name?: string;
  file_url?: string;
  created_at?: string;
}

export interface ICreateGalleryPayload {
  folder_name: string;
  files: File[]; // adjust based on your backend (FormData likely needed)
}

export interface IGalleryListParams {
  folderName?: string;
  page?: number;
  pageSize?: number;
  routineId?: string | number;
}


export const galleryReportApi: { [key: string]: any } = createApi({
  reducerPath: 'galleryReportApi',
  baseQuery: baseQuery,
  tagTypes: ['GalleryReports'],
  endpoints: (build) => ({
    listGalleryReports: build.query<Response<IGalleryItem[]>, void>({
      query: () => ({
        url: `reports/gallery/list`,
        method: 'GET'
      }),
      providesTags: [{ type: 'GalleryReports', id: 'PARTIAL-LIST' }]
    }),

    listGalleryByFolder: build.query<Response<IGalleryItem[]>, IGalleryListParams>({
      query: ({ folderName, page = 1, pageSize = 12, routineId }) => {
        const params = new URLSearchParams({
          pageNo: String(page),
          pageSize: String(pageSize),
          ...(routineId ? { routineId: String(routineId) } : {})
        });
        return {
          url: `reports/gallery/list/${folderName}?${params.toString()}`,
          method: 'GET'
        };
      },
      providesTags: [{ type: 'GalleryReports', id: 'PARTIAL-LIST' }]
    }),

    createGalleryReport: build.mutation<Response<IGalleryItem>, FormData>({
      query: (body) => ({
        url: `reports/gallery/create`,
        method: 'POST',
        body
      }),
      invalidatesTags: [{ type: 'GalleryReports', id: 'PARTIAL-LIST' }]
    }),

    deleteGalleryReport: build.mutation<Response<any>, { path: string }>({
      query: (path) => ({
        url: `reports/gallery/delete?path=${path}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'GalleryReports', id: 'PARTIAL-LIST' }]
    })
  })
});


export const {
  useListGalleryReportsQuery,
  useListGalleryByFolderQuery,
  useCreateGalleryReportMutation,
  useDeleteGalleryReportMutation
} = galleryReportApi;
